<section class="bc-login">
  <div class="container">
    <div class="row">
      <div class="col-xs-8 col-sm-6 col-md-4 center-block">
        <form class="form-signin" [hidden]="validLogin" (ngSubmit)="login(loginData, rememberMe)" novalidate="novalidate">
          <h2 class="form-signin-heading">{{'bcLogin.form.pleaseLogin' | translate}}</h2>

          <div class="form-group" [hidden]="!message" *ngIf="!identityLogin">
            <div class="alert alert-danger">{{message | translate}}</div>
          </div>

          <div class="form-group" *ngIf="!identityLogin">
            <input id="inputEmail"
                   class="form-control"
                   type="text"
                   placeholder="{{ 'bcLogin.form.userNamePlaceholder' | translate }}"
                   [(ngModel)]="loginData.username"
                   [ngModelOptions]="{standalone: true}"
                   required="required"
                   autofocus="autofocus"/>
          </div>

          <div class="form-group" *ngIf="!identityLogin">
            <input type="password"
                   id="inputPassword"
                   class="form-control"
                   placeholder="{{ 'bcLogin.form.passwordPlaceholder' | translate }}"
                   [(ngModel)]="loginData.password"
                   [ngModelOptions]="{standalone: true}"
                   required="required"/>
          </div>

          <div class="form-group" *ngIf="!identityLogin">
            <label for="cbxRememberMe" class="remember-me-label">
              <input type="checkbox" id="cbxRememberMe" class="remember-me-input" [(ngModel)]="rememberMe" [ngModelOptions]="{standalone: true}"/>
              <span class="remember-me-text">{{'bcLogin.form.rememberMe' | translate}}</span>
            </label>
          </div>

          <button class="btn btn-lg btn-dark btn-block btn-submit" id="loginButton" type="submit" [disabled]="loading" *ngIf="!identityLogin">
            <span *ngIf="loading" class="glyphicon glyphicon-refresh glyphicon-refresh-animate gpu-accelerate no-animate"></span>
            <span *ngIf="!loading">{{'bcLogin.form.signIn' | translate }}</span>
          </button>

          <button class="btn btn-lg btn-dark btn-block btn-submit" id="ssoButton" type="button" *ngIf="displaySSOButton" [disabled]="loading" (click)="transitionToSSOLogin()">
            <span *ngIf="loading" class="glyphicon glyphicon-refresh glyphicon-refresh-animate gpu-accelerate no-animate"></span>
            <span *ngIf="!loading">{{'bcLogin.form.signInWithSSO' | translate }}</span>
          </button>
        </form>
      </div>
    </div>
  </div>
</section>
